import React from "react";
import { Link, useLocation } from "react-router-dom";
import { BiCheckCircle, BiChevronRight } from "react-icons/bi";

export default function StripeConnectSuccess() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const isConnected = params.get("stripe_connected") === "1";

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-6">
      <div className="bg-white shadow-md rounded-xl p-8 max-w-md w-full text-center">
        
        {isConnected ? (
          <>
            <BiCheckCircle className="text-green-600 w-16 h-16 mx-auto mb-4" />

            <h1 className="text-2xl font-bold text-gray-800 mb-2">
              Stripe Connected Successfully
            </h1>

            <p className="text-gray-600 mb-6">
              Your Stripe account is now connected.  
              You can start receiving payments immediately.
            </p>

            <Link
              to="/dashboard/admin"
              className="inline-flex items-center bg-indigo-600 text-white px-5 py-3 rounded-lg shadow hover:bg-indigo-700 transition"
            >
              Go to Dashboard
              <BiChevronRight className="ml-2 w-5 h-5" />
            </Link>
          </>
        ) : (
          <>
            <h1 className="text-xl font-bold text-gray-800 mb-2">
              Stripe Connection Status
            </h1>

            <p className="text-gray-600 mb-6">
              It looks like we couldn’t verify your Stripe connection.
            </p>

            <Link
              to="/settings/payments"
              className="inline-flex items-center bg-red-500 text-white px-5 py-3 rounded-lg shadow hover:bg-red-600 transition"
            >
              Retry Stripe Setup
              <BiChevronRight className="ml-2 w-5 h-5" />
            </Link>
          </>
        )}

      </div>
    </div>
  );
}
